<template>
  <DsfFormControlBox
    class="ds-date-picker"
    :owner="_self"
    :block-class="{ 'ds-error-border': errors.length > 0 }"
  >
    <template v-slot:simple>
      <span :title="readOnlyText">{{ readOnlyText }}</span>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
    <template v-slot:content>
      <el-time-picker
        v-if="!readOnly"
        v-model="timeValue"
        :disabled="disabled"
        :editable="false"
        :clearable="clearable"
        :range-separator="rangeSeparator"
        :value-format="valueFormat"
        :arrow-control="arrowControl"
        :start-placeholder="startPlaceholder"
        :end-placeholder="endPlaceholder"
        is-range
        :format="optionFormat"
        @change="changeHandler"
      />
      <!--只读状态只显示div-->
      <div v-else-if="readOnly" class="ds-form-readonly">
        <span :title="readOnlyText">{{ readOnlyText }}</span>
      </div>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>

<script>
export default dsf.component({
  name: "DsfTimeIntervalPicker",
  mixins: [$mixins.formControl],
  ctrlCaption: "时间区间",
  props: {
    value: {
      type: Object,
      default() {
        return {
          stime: "",
          etime: "",
        };
      },
    },
    label: {
      type: String,
      default: "时间区间",
    },
    startPlaceholder: {
      type: String,
      default: "开始时间",
    },
    endPlaceholder: {
      type: String,
      default: "结束时间",
    },
    // 分隔符
    rangeSeparator: {
      type: String,
      default: "-",
    },
    // 时间显示格式
    timeFormat: {
      type: String,
      default: "HH:mm",
    },
    // 是否显示清除按钮
    clearable: {
      type: Boolean,
      default: true,
    },
    // 显示小时段
    timeInter: {
      type: Array,
      default() {
        return ["00:00:00", "23:59:59"];
      },
    },
    // 只读状态下格式化
    formatter: {
      type: String,
      default: "dateTime^hh:ii",
    },
    // 是否使用箭头进行时间选择
    arrowControl: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("time-interval-meta-data");
      },
    },
    //用于二次开发的 pickerOptions
    mPicker: {
      type: Object,
      required: false,
    },
  },
  // watch: {
  //   value: {
  //     handler(to) {
  //       this.initValue(to);
  //     },
  //     immediate: true,
  //     deep: true
  //   }
  // },
  computed: {
    timeValue: {
      get() {
        if (!this.value || !this.value?.stime || !this.value?.etime) {
          return null;
        }
        let stime = this.value.stime.split(":"),
          etime = this.value.etime.split(":");
        let f = this.timeFormat;
        let res = [
          [stime?.[0] || "00", stime?.[1] || "00"].join(":"),
          [etime?.[0] || "23", etime?.[1] || "59"].join(":"),
        ];
        if (["HH:mm:ss", "HH点mm分ss秒", "H点m分s秒"].includes(f)) {
          res[0] += ":" + (stime?.[2] || "00");
          res[1] += ":" + (etime?.[2] || "59");
        }
        return this.timeComparison(res);
      },
      set(v) {
        if (!v) {
          v = ["", ""];
        }
        if (this.value?.stime !== v[0] || this.value?.etime !== v[1]) {
          let time = this.timeComparison(v);
          this.emitValueChange({
            stime: time[0],
            etime: time[1],
          });
        }
      },
    },
    readOnlyText() {
      let v = this.timeValue;
      if (!v) {
        return "";
      }
      let f = this.formatter.replace("dateTime^", "");
      return dsf.date.format(v[0], f) + " - " + dsf.date.format(v[1], f);
    },
    valueFormat() {
      if (["HH:mm:ss", "HH点mm分ss秒", "H点m分s秒"].includes(this.timeFormat))
        return "HH:mm:ss";
      return "HH:mm";
    },
    optionFormat() {
      if (this.timeFormat === "H点m分s秒") return "HH点mm分ss秒";
      if (this.timeFormat === "H点m分") return "HH点mm分";
      return this.timeFormat;
    },
  },
  methods: {
    changeHandler() {
      this.$nextTick(() => {
        this.$dispatch("change", this.value);
        this.emitFormValidate(this.value);
      });
    },
    // 时间比较
    timeComparison(times) {
      let yyyyMMdd = `${new Date().getFullYear()}/${
          new Date().getMonth() + 1
        }/${new Date().getDate()}`,
        result = times;

      _.forEach(result, (time, index) => {
        let comparisonTimeStamp = new Date(
          `${yyyyMMdd} ${this.timeInter[index]}`
        ).getTime();
        if (
          (index === 0 &&
            new Date(`${yyyyMMdd} ${time}`).getTime() < comparisonTimeStamp) ||
          (index === 1 &&
            new Date(`${yyyyMMdd} ${time}`).getTime() > comparisonTimeStamp)
        )
          result[index] = this.timeInter[index];
      });
      return result;
    },
  },
});
</script>
